import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import { getRenderBonusName, GetRenderBonusNameType } from '../cells/headerCells/getRenderBonusName';
import { getRenderBonusAmount, GetRenderBonusAmountType } from '../cells/headerCells/getRenderBonusAmount';

export const getHeaderCellsCreator = ({
    style,
    showTermsPopup,
    showCancelBonusPopup,
    translate,
    isDesktop
}: GetRenderBonusNameType & GetRenderBonusAmountType) => (item: IBonusToDisplay) => [{
    id: 0,
    content: getRenderBonusName({ style, showTermsPopup, translate })(item),
    className: `${style.smallDetails} accordionHeaderSmallDetails`
}, {
    id: 1,
    content: getRenderBonusAmount({ isDesktop, style, showCancelBonusPopup, translate })(item),
    className: `${style.smallDetailsEnd} accordionHeaderSmallDetails`
}];

